import {Circle} from "react-konva";
import type {GridPoint} from "@/dungeons/model/DungeonGeometry.ts";
import type {GeometrySnapTarget} from "./GeometrySnapping.ts";

export default function GeometrySnapMarker({point, target, zoom}: {
    point: GridPoint;
    target: GeometrySnapTarget;
    zoom: number;
}) {
    const color = target === "point" ? "#f472b6"
        : target === "segment" ? "#a3e635"
            : target === "grid-intersection" ? "#22d3ee"
                : target === "grid-line" ? "#38bdf8" : "#94a3b8";
    return <Circle x={point.x} y={point.y} radius={8 / zoom} stroke={color}
                   strokeWidth={2 / zoom} dash={target === "free" ? [3 / zoom, 3 / zoom] : undefined}/>;
}
